import styled, { css } from "styled-components";

export const ButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 16px;
  align-items: center;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  & > button {
    flex: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 238px;

  p {
    margin-top: 8px;
    margin-bottom: 24px;
    font-family: "Inter";
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    color: #020618;
  }

  .anticon.anticon-exclamation-circle {
    min-width: 80px;
    min-height: 80px;
  }

  svg {
    color: #002244;
    min-width: 80px;
    min-height: 80px;
  }

  div {
    margin-top: 0;
    flex-direction: column;
    gap: 8px;

    button {
      width: 100% !important;
    }
  }
`;
